import { render, staticRenderFns } from "./PagePaymentReceipt.vue?vue&type=template&id=128c4141&scoped=true&"
import script from "./PagePaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./PagePaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentReceipt.vue?vue&type=style&index=0&id=128c4141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c4141",
  null
  
)

export default component.exports